import { IContextShape, IErrorMeta } from '../model'

export const context = (context: JSONPrimitiveObject): IErrorMeta<IContextShape> => ({
  errors: { context },
})
